import { useQuery } from '@tanstack/react-query';
import { fetchRoutes, RouteDto } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useRoutes = () =>
  useQuery({
    queryFn: async () => {
      const response = await extractData(
        fetchRoutes({
          query: { PageNumber: 1, PageSize: 250 },
        })
      );
      return (response.page?.items ?? []) as Array<
        RouteDto & { id: number; name: string }
      >;
    },
    queryKey: ['routes'],
  });
